import React from "react";
import addButtonIcon from "../../assets/profile/add-button.png"
type AddButtonProps = {
  onClick?: () => void;
  disabled?: boolean;

};

export const AddButton: React.FC<AddButtonProps> = ({ onClick, disabled }) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`border-solid rounded-full outline-none bg-none relative ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <img width={40} height={40} alt="add button" src={addButtonIcon} />
      {disabled && (
        <div className="absolute inset-0 bg-gray-900 bg-opacity-60 rounded-full pointer-events-none" />
      )}
    </button>
  );
}